export default {"src":"/login/_next/static/media/favicon.964a6484.ico","height":16,"width":16,"blurWidth":0,"blurHeight":0};